import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

import {
    DialogModule,
    DataTableModule
} from 'primeng/primeng';

import { ProductSelectDialogComponent } from './product-select-dialog.component';

@NgModule({
    imports: [
        CommonModule,
        TranslateModule,
        DialogModule,
        DataTableModule
    ],
    declarations: [
        ProductSelectDialogComponent
    ],
    exports: [
        ProductSelectDialogComponent
    ]
})
export class ProductSelectDialogModule { }



// WEBPACK FOOTER //
// /var/www/vhosts/s-wines.nl/httpdocs/crm/resources/assets/src/app/shared/modules/product-select-dialog/product-select-dialog.module.ts